import { State } from "./types";

const initialState: State = [];

export { initialState };
